import { BarChart, ComponentAlignment } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

const barChartData = [
  {
    quarter: 'Q1 2022',
    revenue: 4200,
    profit: 2400,
    expenses: 1800,
    marketing: 800,
    sales: 1200,
    operations: 1600,
    research: 600,
    customers: 2400,
    retention: 85,
    acquisition: 320,
  },
  {
    quarter: 'Q2 2022',
    revenue: 5100,
    profit: 2800,
    expenses: 2300,
    marketing: 950,
    sales: 1350,
    operations: 1800,
    research: 700,
    customers: 2600,
    retention: 82,
    acquisition: 380,
  },
  {
    quarter: 'Q3 2022',
    revenue: 6300,
    profit: 3500,
    expenses: 2800,
    marketing: 1100,
    sales: 1500,
    operations: 2000,
    research: 800,
    customers: 2950,
    retention: 88,
    acquisition: 450,
  },
  {
    quarter: 'Q4 2022',
    revenue: 7500,
    profit: 4200,
    expenses: 3300,
    marketing: 1300,
    sales: 1700,
    operations: 2200,
    research: 900,
    customers: 3300,
    retention: 90,
    acquisition: 520,
  },
  {
    quarter: 'Q1 2023',
    revenue: 6800,
    profit: 3800,
    expenses: 3000,
    marketing: 1200,
    sales: 1600,
    operations: 2100,
    research: 850,
    customers: 3100,
    retention: 87,
    acquisition: 480,
  },
  {
    quarter: 'Q2 2023',
    revenue: 7800,
    profit: 4500,
    expenses: 3300,
    marketing: 1350,
    sales: 1800,
    operations: 2300,
    research: 950,
    customers: 3400,
    retention: 89,
    acquisition: 540,
  },
  {
    quarter: 'Q3 2023',
    revenue: 8900,
    profit: 5200,
    expenses: 3700,
    marketing: 1500,
    sales: 2000,
    operations: 2500,
    research: 1100,
    customers: 3800,
    retention: 92,
    acquisition: 620,
  },
  {
    quarter: 'Q4 2023',
    revenue: 10200,
    profit: 6100,
    expenses: 4100,
    marketing: 1700,
    sales: 2300,
    operations: 2800,
    research: 1300,
    customers: 4200,
    retention: 93,
    acquisition: 680,
  },
  {
    quarter: 'Q1 2024',
    revenue: 9500,
    profit: 5600,
    expenses: 3900,
    marketing: 1600,
    sales: 2100,
    operations: 2600,
    research: 1200,
    customers: 3900,
    retention: 91,
    acquisition: 640,
  },
  {
    quarter: 'Q2 2024',
    revenue: 10800,
    profit: 6500,
    expenses: 4300,
    marketing: 1800,
    sales: 2400,
    operations: 2900,
    research: 1400,
    customers: 4300,
    retention: 94,
    acquisition: 710,
  },
]

export const BarChartDemo = () => {
  return (
    <LayoutDemo title='Bar Chart' bgColor='var(--color-primary-80)'>
      <div className='min-h-[300px] h-full w-full flex items-center justify-center px-1'>
        <BarChart
          id='bar-chart'
          width={'100%'}
          height={'100%'}
          alignment={'center' as ComponentAlignment}
          margin={{
            top: 30,
            right: 0,
            bottom: 0,
            left: 0,
          }}
          xAxisKey='quarter'
          dataKeys={[
            'revenue',
            'profit',
            'expenses',
            'marketing',
            'sales',
            'operations',
            'research',
            'customers',
            'retention',
            'acquisition',
          ]}
          stacked={true}
          orientation='vertical'
          showLegend={true}
          legendGap={0}
          showTooltip={true}
          showGrid={true}
          showAxis={false}
          abbreviateLabel={false}
          sequenceType='sequential'
          data={barChartData}
          backgroundColor='primary-80'
        />
      </div>
    </LayoutDemo>
  )
}
